"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const countries_1 = require("../countries");
const stateCodes_1 = require("../stateCodes");
const insuranceLicense_1 = __importDefault(require("./insuranceLicense"));
class Licensing {
    constructor(id, name, country, state, licenses, notes, description, lastModifiedDate, lastModifiedBy) {
        this.id = id;
        this.name = name;
        this.country = country;
        this.state = state;
        this.licenses = licenses;
        this.notes = notes;
        this.description = description;
        this.lastModifiedDate = lastModifiedDate;
        this.lastModifiedBy = lastModifiedBy;
    }
    static fromObj(data) {
        if (data.licenses) {
            return new Licensing(data.id, data.name, data.country, data.state, data.licenses ? data.licenses.map(insuranceLicense_1.default.fromObj) : [], data.notes, data.description, data.lastModifiedDate, data.lastModifiedBy);
        }
        const { id, country, state } = data;
        const countryName = countries_1.getCountryName(country);
        const stateName = stateCodes_1.stateCodes.getStateName(country, state);
        const name = `${stateName}, ${countryName}`;
        const license = insuranceLicense_1.default.fromObj(data);
        const description = `${license.type} ${license.number}`;
        return new Licensing(id, name, country, state, [license], data.notes, description);
    }
}
exports.default = Licensing;
//# sourceMappingURL=licensing.class.js.map